import txFailed from "@/controller/txFailed";
import store from "@/store";
import openTxDialog from "@/controller/openTxDialog";

export function throwError(){
    store.commit('updateCheckModel', false)
    store.commit('updateConfirmDialog', true)
    store.commit('updateErrorContext',1000)
    txFailed()
}